// Dev-only logger. In production builds (NODE_ENV === 'production') every
// call is a no-op, so silent failures never leak to end-users' DevTools
// or to error trackers, while developers still get the stack trace in
// preview. Replaces both ad-hoc `console.error` calls in catch blocks
// and the bare `console.log` debugging leftovers flagged by code review.

const isDev = process.env.NODE_ENV !== "production";

export const devError = (...args) => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.error(...args);
    }
};

export const devWarn = (...args) => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.warn(...args);
    }
};

export const devLog = (...args) => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.log(...args);
    }
};
